import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: _vm.cssVars },
    [
      _c(
        VBreadcrumbs,
        { staticClass: "d-print-none" },
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v("Home")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            {
              attrs: {
                exact: true,
                to: { name: "processWorksheet", params: {} },
              },
            },
            [_vm._v(" Process Worksheet ")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            { attrs: { to: { name: "processWorksheetView", params: {} } } },
            [_vm._v(" Worksheet Print QR Code ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-print-none" },
        [
          _c("page-params", {
            attrs: {
              pageName: "worksheetPrintQR",
              vuexName: "qrPrintParameters",
              parameters: _vm.settings,
            },
          }),
          _c(VDivider),
          _c(VSubheader, [_vm._v("Print Settings")]),
          _c("div", [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(VTextField, {
                  staticClass: "mx-2",
                  attrs: { label: "Brand Name", outlined: "", dense: "" },
                  model: {
                    value: _vm.parameters.brandName,
                    callback: function ($$v) {
                      _vm.$set(_vm.parameters, "brandName", $$v)
                    },
                    expression: "parameters.brandName",
                  },
                }),
                _c(VTextField, {
                  staticClass: "mx-2",
                  attrs: {
                    label: "Commodity Override",
                    outlined: "",
                    dense: "",
                  },
                  model: {
                    value: _vm.parameters.commodityOverride,
                    callback: function ($$v) {
                      _vm.$set(_vm.parameters, "commodityOverride", $$v)
                    },
                    expression: "parameters.commodityOverride",
                  },
                }),
                _c(
                  VBtn,
                  {
                    staticClass: "ml-2",
                    on: {
                      click: function ($event) {
                        return _vm.addStickerField()
                      },
                    },
                  },
                  [_vm._v("Add Field")]
                ),
              ],
              1
            ),
          ]),
          _vm._l(_vm.parameters.optionalFields, function (field, index) {
            return _c("div", { key: index }, [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(VTextField, {
                    staticClass: "mx-2",
                    attrs: { label: "Field Label", outlined: "", dense: "" },
                    model: {
                      value: field.label,
                      callback: function ($$v) {
                        _vm.$set(field, "label", $$v)
                      },
                      expression: "field.label",
                    },
                  }),
                  _c(VTextField, {
                    staticClass: "mx-2",
                    attrs: { label: "Field Value", outlined: "", dense: "" },
                    model: {
                      value: field.value,
                      callback: function ($$v) {
                        _vm.$set(field, "value", $$v)
                      },
                      expression: "field.value",
                    },
                  }),
                  _c(
                    VBtn,
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.deleteField(index)
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v("mdi-delete-outline")])],
                    1
                  ),
                ],
                1
              ),
            ])
          }),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c(VTextField, {
                staticClass: "mx-2",
                attrs: { suffix: "px", outlined: "", dense: "", label: "Left" },
                model: {
                  value: _vm.parameters.left,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "left", $$v)
                  },
                  expression: "parameters.left",
                },
              }),
              _c(VTextField, {
                staticClass: "mx-2",
                attrs: { suffix: "px", outlined: "", dense: "", label: "Top" },
                model: {
                  value: _vm.parameters.top,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "top", $$v)
                  },
                  expression: "parameters.top",
                },
              }),
              _c(VTextField, {
                staticClass: "mx-2",
                attrs: {
                  suffix: "px",
                  outlined: "",
                  dense: "",
                  label: "Right",
                },
                model: {
                  value: _vm.parameters.right,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "right", $$v)
                  },
                  expression: "parameters.right",
                },
              }),
              _c(VTextField, {
                staticClass: "mx-2",
                attrs: {
                  suffix: "px",
                  outlined: "",
                  dense: "",
                  label: "Bottom",
                },
                model: {
                  value: _vm.parameters.bottom,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "bottom", $$v)
                  },
                  expression: "parameters.bottom",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c(VTextField, {
                staticClass: "mx-2",
                attrs: {
                  suffix: "pt",
                  outlined: "",
                  dense: "",
                  label: "Font Size",
                },
                model: {
                  value: _vm.parameters.fontSize,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "fontSize", $$v)
                  },
                  expression: "parameters.fontSize",
                },
              }),
              _c(VTextField, {
                staticClass: "mx-2",
                attrs: {
                  suffix: "pt",
                  outlined: "",
                  dense: "",
                  label: "Header Font Size",
                },
                model: {
                  value: _vm.parameters.headerFontSize,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "headerFontSize", $$v)
                  },
                  expression: "parameters.headerFontSize",
                },
              }),
              _c(VTextField, {
                staticClass: "mx-2",
                attrs: {
                  suffix: "pt",
                  outlined: "",
                  dense: "",
                  label: "Footer Font Size",
                },
                model: {
                  value: _vm.parameters.footerFontSize,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "footerFontSize", $$v)
                  },
                  expression: "parameters.footerFontSize",
                },
              }),
              _c(VTextField, {
                staticClass: "mx-2",
                attrs: {
                  suffix: "pt",
                  outlined: "",
                  dense: "",
                  label: "QR Code Size",
                },
                model: {
                  value: _vm.parameters.qrSize,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "qrSize", $$v)
                  },
                  expression: "parameters.qrSize",
                },
              }),
              _c(VTextField, {
                staticClass: "mx-2",
                attrs: {
                  suffix: "cols",
                  outlined: "",
                  dense: "",
                  label: "Number of Columns",
                },
                model: {
                  value: _vm.parameters.cols,
                  callback: function ($$v) {
                    _vm.$set(_vm.parameters, "cols", $$v)
                  },
                  expression: "parameters.cols",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-center" },
            [
              _c(VTextField, {
                staticClass: "mx-2 flex-grow-1",
                attrs: {
                  outlined: "",
                  dense: "",
                  label: "Filter entries",
                  hint: "Example: 1, 2, 5 - 10",
                },
                model: {
                  value: _vm.filterTerm,
                  callback: function ($$v) {
                    _vm.filterTerm = $$v
                  },
                  expression: "filterTerm",
                },
              }),
              _c(VTextField, {
                staticClass: "mx-2 flex-grow-0",
                attrs: { outlined: "", dense: "", label: "Empty Padding" },
                model: {
                  value: _vm.emptyPadding,
                  callback: function ($$v) {
                    _vm.emptyPadding = _vm._n($$v)
                  },
                  expression: "emptyPadding",
                },
              }),
              _c(
                VBtn,
                {
                  staticClass: "mx-2",
                  on: {
                    click: function ($event) {
                      return _vm.print()
                    },
                  },
                },
                [_vm._v("Print")]
              ),
            ],
            1
          ),
          _c(VDivider, { staticClass: "mb-5" }),
        ],
        2
      ),
      _c(
        VRow,
        {
          staticClass: "sticker-container",
          attrs: { "align-content": "center" },
        },
        _vm._l(_vm.filteredEntries, function (entry) {
          return _c(
            VCol,
            {
              key: entry.id,
              staticClass: "sticker",
              style: {
                paddingTop: _vm.parameters.top + "px",
                paddingRight: _vm.parameters.right + "px",
                paddingBottom: _vm.parameters.bottom + "px",
                paddingLeft: _vm.parameters.left + "px",
                fontSize: _vm.parameters.fontSize + "pt",
              },
              attrs: { cols: "12", sm: "6", md: 12 / _vm.parameters.cols },
            },
            [
              entry.empty
                ? _c("div", [
                    _c("div", { style: `height: ${_vm.cellHeight}px` }),
                  ])
                : _vm._e(),
              !entry.empty
                ? _c("div", [
                    _c("div", {
                      class: _vm.companyName.startsWith("Bergsoe")
                        ? "bg-img"
                        : "panya-bg-img",
                    }),
                    _c(
                      "div",
                      {
                        ref: "cellContent",
                        refInFor: true,
                        staticClass: "cell-content",
                      },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c(
                            "div",
                            { staticClass: "my-auto" },
                            [
                              _c("qriously", {
                                attrs: {
                                  value: _vm.getQrCodeUrl(entry),
                                  size: _vm.parameters.qrSize,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "ml-3" }, [
                            _c("table", { staticClass: "qr-info" }, [
                              _c(
                                "tbody",
                                [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "font-weight-bold",
                                        style: `font-size: ${_vm.parameters.headerFontSize}pt`,
                                        attrs: { colspan: "2" },
                                      },
                                      [_vm._v(_vm._s(_vm.companyName))]
                                    ),
                                  ]),
                                  _vm.parameters.brandName
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "font-weight-light text-caption",
                                          },
                                          [_vm._v("Brand")]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(_vm.parameters.brandName)
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm.commodityName
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "font-weight-light text-caption",
                                          },
                                          [_vm._v("Commodity")]
                                        ),
                                        _c("td", [
                                          _vm._v(_vm._s(_vm.commodityName)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm.processWorksheet.documentNumber
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "font-weight-light text-caption",
                                          },
                                          [_vm._v("Lot No")]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.processWorksheet
                                                .documentNumber
                                            ) +
                                              "-" +
                                              _vm._s(_vm.entryIndex(entry))
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  entry.netWeight != null
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "font-weight-light text-caption",
                                          },
                                          [_vm._v("Net Weight")]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  entry.netWeight +
                                                    (entry.netAdjustmentWeight ||
                                                      0)
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.productInfo
                                                  ? _vm.productInfo
                                                      .measureWeight
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._l(
                                    _vm.parameters.optionalFields,
                                    function (field, index) {
                                      return _c("tr", { key: index }, [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "font-weight-light text-caption",
                                          },
                                          [_vm._v(_vm._s(field.label))]
                                        ),
                                        _c("td", [_vm._v(_vm._s(field.value))]),
                                      ])
                                    }
                                  ),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "font-weight-light text-caption",
                                      },
                                      [_vm._v("Date")]
                                    ),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDateYear")(
                                            _vm.processWorksheet.processTime
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "font-weight-light text-caption",
                                      },
                                      [_vm._v("Origin")]
                                    ),
                                    _c("td", [_vm._v("Thailand")]),
                                  ]),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ]),
                        _vm.companyAddress
                          ? _c(
                              "div",
                              {
                                staticClass: "ma-0 pa-0 font-weight-light",
                                style: `font-size: ${_vm.parameters.footerFontSize}pt;`,
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.companyAddress) +
                                    " Tel: " +
                                    _vm._s(_vm.companyPhone) +
                                    " "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-caption font-weight-light font-size-small d-print-none",
                                    staticStyle: {
                                      float: "right",
                                      position: "relative",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.entryIndex(entry)))]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }